import BannerCase from './banner-case';
import ContentCase from './content-case';

type ListPathType = {
    name: string;
    path: string;
};

type TitleCasePropsType = {
    img: string;
    video?: string;
    className?: string;
    caseName: string;
    listTitle: any;
    listPath: ListPathType[];
    bottomPicture?: boolean;
};

const TitleCase = ({
    img,
    video,
    className = '',
    caseName,
    listTitle,
    listPath,
    bottomPicture,
}: TitleCasePropsType) => {
    return (
        <>
            <BannerCase img={img} video={video} className={className} listPath={listPath} />
            <ContentCase caseName={caseName} bottomPicture={bottomPicture} listTitle={listTitle} />
        </>
    );
};

export default TitleCase;
